export const timeout = (name, delay, promise) => {
    if (delay === null)
        return promise;
    return new Promise((res, rej) => {
        setTimeout(() => rej(new Error(`timeout "${name}" expired after ${delay}ms`)), delay);
        promise.then(res, rej);
    });
};
const timeoutResolve = (delay) => (cb) => setTimeout(cb, delay);
export const sleep = (delay) => new Promise(timeoutResolve(delay));
export const retry = async (fn, retries = 5, interval = 1000) => {
    try {
        return await fn();
    }
    catch (e) {
        if (retries > 0) {
            await sleep(interval);
            return retry(fn, retries - 1, interval);
        }
        throw e;
    }
};
export async function time(p) {
    const start = performance.now();
    const result = await p;
    const end = performance.now();
    const duration = end - start;
    return [result, duration];
}
const idSpread = (...args) => args;
export const reusePending = (fn, opts = {}) => {
    const { serialize = idSpread } = opts;
    const registry = new Map();
    return async (...args) => {
        const key = String(JSON.stringify(serialize(...args)));
        if (registry.has(key)) {
            const res = registry.get(key);
            if (typeof res !== 'undefined') {
                return res;
            }
        }
        const res = fn(...args);
        registry.set(key, res);
        try {
            await res;
        }
        finally {
            registry.delete(key);
        }
        return res;
    };
};
function shift(map) {
    const [key] = Array.from(map.keys());
    map.delete(key);
}
export const cache = (fn, opts = {}) => {
    const { maxAge = Infinity, maxSize = Infinity, useStale = false, serialize = idSpread } = opts;
    const map = new Map();
    return async (...args) => {
        const key = String(JSON.stringify(serialize(...args)));
        const now = Date.now();
        {
            const entry = map.get(key);
            if (entry) {
                const age = now - entry.created;
                if (age < maxAge) {
                    return entry.value;
                }
            }
        }
        try {
            const result = await fn(...args);
            map.set(key, {
                created: now,
                value: result,
            });
            if (map.size > maxSize)
                shift(map);
            return result;
        }
        catch (err) {
            if (!useStale)
                throw err;
            const entry = map.get(key);
            if (entry)
                return entry.value;
            throw err;
        }
    };
};
//# sourceMappingURL=promise.js.map